<template>
  <div :class="$style.pannel">
    <div :class="{[$style.active]: flag==1, [$style.half]: true}" @click="childFunction(1)">5</div>
    <div :class="{[$style.active]: flag==2, [$style.half]: true}" @click="childFunction(2)">5</div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "AboutSelectPannel",

  props: {
    flag: {}
  },
  methods: {
    childFunction(flag) {
      this.$emit("child_event", flag);
    }
  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  .pannel {
    color: #333333;
    display: flex;
    width: 100px;
    height: 60px;
    z-index: 100;
    position: relative;
    top: 80px;
    border-radius: 15px 15px 15px 15px;
    background: rgba(30, 30, 30, 0.9);

    .half {
      font-size: 40px;
      width: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .half:hover {
      border-radius: 15px 15px 15px 15px;
      background: rgba(45, 45, 45, 0.9);
      cursor: pointer;
      cursor: hand;
    }
    .active {
      color: #fff;
      background: rgba(60, 60, 60, 0.9);
      border-radius: 15px 15px 15px 15px;
    }
  }
}
@media only screen and (min-width: 1024px) {
  .pannel {
    color: #888888;
    display: flex;
    width: 100px;
    height: 60px;
    z-index: 100;
    position: relative;
    top: 120px;
    border-radius: 15px 15px 15px 15px;
    background: rgba(30, 30, 30, 0.9);

    .half {
      font-size: 40px;
      width: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .half:hover {
      border-radius: 15px 15px 15px 15px;
      background: rgba(45, 45, 45, 0.9);
      cursor: pointer;
      cursor: hand;
    }
    .active {
      color: #fff;
      background: rgba(60, 60, 60, 0.9);
      border-radius: 15px 15px 15px 15px;
    }
  }
}
</style>
